import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Box, Paper, Tab, Tabs } from "@mui/material";
import DashboardLayout from "../../../layouts/DashboardLayout";
import BusquedaPorIdentificador from "../components/BusquedaPorIdentificador";
import ListadoEquipos from "../components/ListadoEquipos";
import ResumenEquipos from "../components/ResumenEquipos";
import TraspasoEquipos from "../components/TraspasoEquipos";
import InventarioAccesorios from "../components/InventarioAccesorios";
import ConsultaMasivaChips from "../components/ConsultaMasivaChips";

const TABS = [
  "Busqueda por Identificador",
  "Listado de Equipos",
  "Resumen de Equipos",
  "Traspaso",
  "Inventario de Accesorios",
  "Consulta de Chips",
];

function TabPanel({ active, children }) {
  return (
    <Box
      role="tabpanel"
      hidden={!active}
      sx={{ display: active ? "block" : "none" }}
    >
      {children}
    </Box>
  );
}

export default function CentroEquiposPage() {
  const [searchParams] = useSearchParams();
  // Permite llegar con un tab pre-seleccionado desde otra pantalla (ej. el widget
  // "Equipos por recibir" del dashboard, que linkea a ?tab=1).
  const tabInicial = Number(searchParams.get("tab"));
  const [tab, setTab] = useState(
    Number.isInteger(tabInicial) && tabInicial >= 0 && tabInicial < TABS.length ? tabInicial : 0
  );

  return (
    <DashboardLayout>
      <Box
        sx={{
          width: "100%",
          minHeight: "calc(100vh - 64px)",
          bgcolor: "background.default",
          p: { xs: 1, md: 1.5 },
        }}
      >
        <Paper variant="outlined" sx={{ mb: 1, overflow: "hidden" }}>
          <Tabs
            value={tab}
            onChange={(_, value) => setTab(value)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              minHeight: 34,
              "& .MuiTab-root": {
                minHeight: 34,
                py: 0.5,
                px: 1.25,
                fontSize: 12,
                textTransform: "none",
              },
            }}
          >
            {TABS.map((label) => (
              <Tab key={label} label={label} />
            ))}
          </Tabs>
        </Paper>

        <TabPanel active={tab === 0}>
          <BusquedaPorIdentificador />
        </TabPanel>
        <TabPanel active={tab === 1}>
          <ListadoEquipos />
        </TabPanel>
        <TabPanel active={tab === 2}>
          <ResumenEquipos />
        </TabPanel>
        <TabPanel active={tab === 3}>
          <TraspasoEquipos />
        </TabPanel>
        <TabPanel active={tab === 4}>
          <InventarioAccesorios />
        </TabPanel>
        <TabPanel active={tab === 5}>
          <ConsultaMasivaChips />
        </TabPanel>
      </Box>
    </DashboardLayout>
  );
}
